import { observer } from 'mobx-react';
import OrderBlockHeader from 'src/view/screens/OrderScreen/components/OrderBlockHeader/OrderBlockHeader';
import OrderBlockItem from 'src/view/screens/OrderScreen/components/OrderBlockItem/OrderBlockItem';
import { useOrderStoreContext } from '~/view/screens/OrderScreen/context';
import './style.scss';

const PickupRecipientInfo = observer(() => {
  const { store: orderStore } = useOrderStoreContext();

  if (!orderStore.order) return null;

  return (
    <div className="pickup-recipient mb-4 mr-6 p-2">
      <OrderBlockHeader title="recipient" />
      <ul className="d-flex flex-column">
        <OrderBlockItem title="hint_name" titleClassName="pickup-recipient__item-title" data={orderStore.order.stranger_name} />
        <OrderBlockItem title="txt_mobile" titleClassName="pickup-recipient__item-title" data={orderStore.order.stranger_phone} />
      </ul>
    </div>
  );
});

export default PickupRecipientInfo;
